module.exports = __webpack_public_path__ + "img/Angiogenesis-CRC_10X_WTA.95c701c1.png";